// Paketleme ekrani mod tanimlari. Toplama (picking) desenine paralel: once mod secilir
// (araba / sepetsiz / coklu raf), kanal (Hepsiburada/Trendyol/Tacreo) ikincil kimliktir.
export type PackingModeId = 'cart' | 'product' | 'slot';

export interface PackingMode {
  id: PackingModeId;
  // i18n anahtar sonu: screens.packing.modes.<i18nKey>.{title,desc}
  i18nKey: string;
  color: string;
  // MUI ikon adi degil; bilesende ikon eslemesi yapilir.
  icon: 'cart' | 'box' | 'shelf';
}

export const PACKING_MODES: PackingMode[] = [
  { id: 'cart', i18nKey: 'cart', color: '#7b1fa2', icon: 'cart' },
  { id: 'product', i18nKey: 'product', color: '#0288d1', icon: 'box' },
  { id: 'slot', i18nKey: 'slot', color: '#2e7d32', icon: 'shelf' },
];

// Kanal kimligi (logo/renk) toplama tarafindaki tanimdan yeniden kullanilir.
export { PICKING_CHANNELS as PACKING_CHANNELS, findPickingChannel as findPackingChannel } from '../picking/pickingChannels';
export type { PickingChannel as PackingChannel } from '../picking/pickingChannels';
